if (!customElements.get('site-drawer')) {
  customElements.define(
    'site-drawer',
    class SiteDrawer extends window.BAO.CustomElement {
      CLASSES = {
        activeDrawerClass: 'drw-Drawer-active',
      }

      constructor () {
        super()

        this.drawers = this.closest('site-drawers')
        if (!this.drawers)
          throw new Error(
            `${this.nodeName.toLowerCase()} should be inside a <site-drawers> element`
          )

        this._isOpen = false
      }

      get key () {
        return this.getAttribute('key')
      }

      get elements () {
        return {
          trigger: window.BAO.utils.getElement(
            `[data-drawers-trigger=${this.key}]`
          ),
          close: window.BAO.utils.getElement(`[data-drawers-close=${this.key}]`),
        }
      }

      get isOpen () {
        return this._isOpen
      }

      set isOpen (val) {
        this._isOpen = val

        this.classList.toggle(this.CLASSES.activeDrawerClass, val)
      }
    }
  )
}
